import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { showSelector } from 'selectors/testTarget/offers/pdpVideoIcon/show/showSelector';

const showPDPVideoIconSelector = createSelector(isTestTargetReadySelector, showSelector, (testReady, show) => testReady && show);

export { showPDPVideoIconSelector };
